/* eslint-disable no-param-reassign */
// open external links in new tab

function isImageLink(url) {
  const fileExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'];

  const urlParts = url.split('.');
  const extension = urlParts[urlParts.length - 1].toLowerCase();

  return fileExtensions.includes(extension);
}

function isPdfLink(url) {
  const urlParts = url.split('.');
  const extension = urlParts[urlParts.length - 1].toLowerCase();

  return extension === 'pdf';
}

function isValidLink(url) {
  let urlObject = new URL(url).hostname;
  return urlObject;
}

function openExternalLink() {
  const body = document.body;
  let externalIcon;

  if(body.classList.contains('acha')){
    externalIcon = 
      `<span class="external-icon" focusable="false" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M9.5 0.75C9.5 1.16562 9.83438 1.5 10.25 1.5H13.4406L6.46875 8.46875C6.175 8.7625 6.175 9.2375 6.46875 9.52812C6.7625 9.81875 7.2375 9.82187 7.52812 9.52812L14.4969 2.55938V5.75C14.4969 6.16563 14.8313 6.5 15.2469 6.5C15.6625 6.5 15.9969 6.16563 15.9969 5.75V0.75C15.9969 0.334375 15.6625 0 15.2469 0H10.25C9.83438 0 9.5 0.334375 9.5 0.75ZM2.25 1C1.00625 1 0 2.00625 0 3.25V13.75C0 14.9937 1.00625 16 2.25 16H12.75C13.9937 16 15 14.9937 15 13.75V9.75C15 9.33438 14.6656 9 14.25 9C13.8344 9 13.5 9.33438 13.5 9.75V13.75C13.5 14.1656 13.1656 14.5 12.75 14.5H2.25C1.83438 14.5 1.5 14.1656 1.5 13.75V3.25C1.5 2.83437 1.83438 2.5 2.25 2.5H6.25C6.66563 2.5 7 2.16563 7 1.75C7 1.33438 6.66563 1 6.25 1H2.25Z" fill="#000"></path>
        </svg>
      </span> `;
  } 
  else {
    externalIcon = '';
  }

  document.querySelectorAll('a[href]:not(.card):not(.not-ext-link)').forEach((item) => {
    if ((isValidLink(item.href) && window.location.hostname !== new URL(item.href).hostname) && !isImageLink(item.href) || isPdfLink(item.href)) {
      item.target = '_blank';
      item.rel = 'noreferrer nofollow noopener';
      item.classList.add('external-link');
      const span = document.createElement('span');
      span.classList.add('link-text');
      span.innerHTML = item.innerHTML;
      item.textContent = '';
      item.appendChild(span);
      item.insertAdjacentHTML(
        'beforeend', externalIcon,
      );
    }
  });
}

function insertDownloadIcon() {
  const extensions = ['doc', 'docx', 'odt', 'rtf', 'wpd', 'xls', 'xlsx', 'csv', 'ppt', 'pptx', 'odp', 'key', 'txt', 'pages', 'tex', 'md', 'zip', 'rar', 'gz', 'tar'];

  document.querySelectorAll('.page-search-listing a[href]').forEach((item) => {
    const urlParts = item.href.split('.');
    const extension = urlParts[urlParts.length - 1].toLowerCase();

    if (extensions.includes(extension) && !item.querySelector('.download-icon')) {
      const span = document.createElement('span');
      span.classList.add('link-text');
      span.innerHTML = item.innerHTML;
      item.textContent = '';
      item.appendChild(span);
      item.insertAdjacentHTML(
        'beforeend',
        `<span class="download-icon" focusable="false" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path d="M5 12V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V12" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 3L12 15M12 15L16 11M12 15L8 11" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>`,
      );
    }
  });
}

window.addEventListener('load', () => {
  openExternalLink();
  insertDownloadIcon();
});
